import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';
import TableContent from './table-content';
import { useLayout } from '../layout/context';

const Table = ({ rows, heading }) => {
  const { insideContainer } = useLayout();

  if (!rows || !rows.length) return null;
  return (
    <Wrapper $padding={!insideContainer}>
      {heading ? <h2>{heading}</h2> : null}
      <TableContent rows={rows} />
    </Wrapper>
  );
};

Table.propTypes = {
  rows: PropTypes.array,
  heading: PropTypes.string,
};

export default Table;

export const TableAssembly = ({ contentfulData }) => (
  <Table
    rows={contentfulData.table && contentfulData.table.tableData}
    heading={contentfulData.tableHeader}
  />
);

TableAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
